// Labels and formatting shared by the Adyen statement view and its tables.

export const BUCKET_LABELS = {
  payments: 'Payments',
  refunds: 'Refunds',
  chargebacks: 'Chargebacks',
  fees: 'Fees',
  payouts: 'Payouts to bank',
  other: 'Other',
};

export const BUCKETS = Object.keys(BUCKET_LABELS);

export const money = (value) => {
  const amount = Number(value || 0);
  const sign = amount < 0 ? '-' : '';
  return `${sign}$${Math.abs(amount).toFixed(2)}`;
};
